import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import useCustomer from '@/hooks/user/useCustomer';
import { ChatbotWidget } from './ChatbotWidget';
import ZendeskChatWidget from './ZendeskChatWidget';

interface HelpdeskSelectorProps {
  bottomOffset?: number;
}

function HelpdeskSelector({ bottomOffset }: HelpdeskSelectorProps) {
  const { data: customer } = useCustomer();
  const enableEscriptChatbot = useFeatureFlag('enable_escript_chatbot');
  const enableUmedsChatbot = useFeatureFlag('enable_umeds_chatbot');

  /*
    Seperate control for displaying the chatbot to eScript customers.
    See https://montugroup.atlassian.net/wiki/spaces/Eng/pages/730202287/
   */
  if (customer?.isExternal && !enableEscriptChatbot) {
    return <ZendeskChatWidget />;
  }

  if (enableUmedsChatbot) {
    return <ChatbotWidget bottomOffset={bottomOffset} />;
  }

  return <ZendeskChatWidget />;
}

export default HelpdeskSelector;
